export class GetOrganisation {
  static readonly type = '[Organisation] GetOrganisation';
  constructor(public organisationId: string, public organisationName?: string) {}
}
